import React from 'react';
import PropTypes from 'prop-types';
import './SpeakerDetails.css';

import ProgramCard from '../../Program/components/ProgramCard';

export default class SpeakerDetails extends React.PureComponent {
    async componentDidMount() {
        window.scrollTo(0, 0);
    }

    onTalkClick = (talkId, track) => e => {
        const screen = track === 'Workshops' ? 'workshops' : 'program';
        if (e.target.id !== 'video-link') {
            this.props.pushAction(`/${screen}/${talkId}`);
        }
    };

    redirect = () => this.props.goBackAction();

    render() {
        const { id } = this.props.match.params;
        const nullSpeaker = <h4 className="title is-4">Oops ! There is no such speaker.</h4>;
        const content = !this.props.details.id ? (
            nullSpeaker
        ) : (
            <div className="card">
                <div className="columns is-centered">
                    {this.props.fetchingSpeakers ? (
                        <i
                            className="fa fa-spinner fa-spin fa-3x fa-fw"
                            style={{ color: '#7500c0' }}
                        />
                    ) : (
                        <div className="column is-four-fifths is-10-mobile is-offset-1-mobile">
                            <div className="underline">
                                <div className="info">
                                    <div className="speaker-photo">
                                        <img
                                            alt="speaker"
                                            className="img"
                                            onError={e => {
                                                e.target.src = 'imgs/speakers/unknown.png';
                                            }}
                                            src={`imgs/speakers/${id}.jpg`}
                                        />
                                    </div>
                                    <h4 className="title is-4" id="name">
                                        {this.props.details.name}
                                    </h4>
                                    <p className="title is-6">{this.props.details.company}</p>
                                    <p className="description">{this.props.details.longDesc}</p>
                                </div>
                            </div>

                            <div>
                                <h4 className="title is-4 talks-title">Talks</h4>
                                <div className="columns is-multiline">
                                    {this.props.details.talks.map(talk => {
                                        const trackInSlot = {
                                            Innovations: 'slot1',
                                            Security: 'slot2',
                                            'Digital Transformation': 'slot3',
                                            Interfaces: 'slot4',
                                            Data: 'slot5',
                                            'Lightning Talk': 'slot6',
                                            'Live Coding Session': 'slot6',
                                            'Hands-on Lab': 'workshop'
                                        };
                                        const speakers = {};
                                        speakers[talk.id] = [];
                                        talk.speakers.forEach(speakerId => {
                                            if (this.props.speakersById[speakerId]) {
                                                speakers[talk.id].push(
                                                    this.props.speakersById[speakerId].name
                                                );
                                            }
                                        });
                                        return (
                                            <ProgramCard
                                                id={talk.id}
                                                key={talk.id}
                                                onClickHandler={this.onTalkClick}
                                                room={talk.room || ''}
                                                screen="program"
                                                speakers={speakers || {}}
                                                talks={[talk] || []}
                                                tileRole="TALK"
                                                time=""
                                                track={trackInSlot[talk.track]}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <button
                    className="button is-large is-rounded btn-submit back-btn"
                    onClick={this.redirect}
                    type="button"
                >
                    Back
                </button>
            </div>
        );

        return (
            <div id="speaker-details-section">
                <section className="section sp-form" id="speaker-details">
                    <div className="container sp-container">{content}</div>
                </section>
            </div>
        );
    }
}

SpeakerDetails.defaultProps = {
    details: {}
};

SpeakerDetails.propTypes = {
    details: PropTypes.objectOf(PropTypes.any),
    fetchingSpeakers: PropTypes.bool.isRequired,
    goBackAction: PropTypes.func.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    pushAction: PropTypes.func.isRequired,
    speakersById: PropTypes.objectOf(PropTypes.any).isRequired
};
